/* Small formatting helpers shared across the expense screens. Amounts arrive from the
   accounting-api as decimal STRINGS (BigDecimal) — never parse them into floats for
   storage/round-tripping; format only for display. */

/** Format a decimal-string (or number) amount as USD for display. Null → em dash. */
export function money(amount: string | number | null | undefined): string {
  if (amount == null || amount === '') return '—';
  const n = typeof amount === 'number' ? amount : Number(amount);
  if (Number.isNaN(n)) return String(amount);
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

/** Format an ISO date/datetime for display. Null → em dash. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/** The current YYYY-MM period code. */
export function currentPeriod(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

/** EXP-<period>-<zero-padded id> reference for a report. */
export function reportReference(periodCode: string, reportId: number): string {
  return `EXP-${periodCode}-${String(reportId).padStart(4, '0')}`;
}
